import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IEmergencyContact } from 'src/app/models/IEmergencyContact';
import { ActivatedRoute, Router } from '@angular/router';
import { PersonalInfoService } from 'src/app/Services/Demographics/personal-info.service';
import { IAttributes } from 'src/app/models/IAttributes';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { ToastrService } from 'ngx-toastr';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { MatDialog } from '@angular/material';
import { LockService } from 'src/app/Services/LockService/lock-service.service';
import { MessageInbox } from 'src/app/models/IMessaging';
import { PatientBannerService } from 'src/app/patient-banner/patient-banner.service';

@Component({
  selector: 'app-ppemergency-request',
  templateUrl: './ppemergency-request.component.html',
  styleUrls: ['./ppemergency-request.component.css']
})
export class PPEmergencyRequestComponent implements OnInit {

  PatientEmergencyForm: FormGroup;
  emergencyInfo: IEmergencyContact;
  currEmergencyInfo: IEmergencyContact;
  public lstattrbutes: IAttributes[];
  public linkID: number;
  public emergencyId: number;
  public requestType: number;
  lstEmergencyContact: IEmergencyContact;
  lstPPEmergency: IEmergencyContact;
  isDisabledExistingdata: boolean = true;
  isDisableRejectReason: boolean = false;
  isVisableRejectreason: boolean = false;
  isVisableRejectedBy: boolean = false;
  isDisableDemographicsbutton: boolean = false;
  rejectedBy: string = '';
  rejectedDate: string = '';

  maxChars = 230;
  charCount = '';
  isPatientStatus: boolean = false;
  patientId: number = 0;
  hideRejectbutton: boolean = true;
  hideRejectReason: boolean = true;
  rejectNotes: string = '';
  emrgLastname: string = "";
  constructor(
    private fb: FormBuilder
    , private route: ActivatedRoute
    , private personalService: PersonalInfoService
    , private router: Router
    , public dialog: MatDialog
    // , private app: AppComponent
    , private toastr: ToastrService
    , private sharedService: SharedService
    , private lockService: LockService
    , private bannerService: PatientBannerService
  ) { }

  ngOnInit() {
    this.PatientEmergencyForm = this.fb.group({
      rejectNotes: ['', Validators.required],
      rejectReason: [''],

    })
    this.linkID = Number(this.route.snapshot.paramMap.get('linkId'));
    this.emergencyId = Number(this.route.snapshot.paramMap.get('emergencyId'));
    this.requestType = Number(this.route.snapshot.paramMap.get('RequestType'));
    if (this.emergencyId != 0 && this.emergencyId != undefined && this.emergencyId != null) {
      this.isDisabledExistingdata = true;
    } else {
      this.isDisabledExistingdata = false;
    }
    this.getPatientRequestDetails(this.linkID);
    this.getEmergencycontactInfo(this.emergencyId, this.linkID);
  }

  getEmergencycontactInfo(id: number, linkid: number) {
    ;
    this.personalService.getEmergencyRequestInformationById(id, linkid)
      .subscribe(
        (data: any) => {
          this.lstEmergencyContact = data;
        },
        (err: any) => console.log(err)
      );
  }

  getPatientRequestDetails(linkID: number) {
    ;
    this.personalService.getEmergencyRequestInformationByLinkId(linkID, this.requestType)
      .subscribe(
        (dataRef: any) => {
          ;
          this.lstPPEmergency = dataRef;
          if (this.lstPPEmergency.requestStatus == 'Rejected') {
            if (this.lstPPEmergency.comments == null || this.lstPPEmergency.comments == "") {
              this.isDisableRejectReason = false;
            } else {
              this.hideRejectbutton = false;
              this.hideRejectReason = true;
              this.PatientEmergencyForm.patchValue({
                rejectNotes: this.lstPPEmergency.comments,
                rejectReason: true
              })
              this.rejectNotes = this.lstPPEmergency.comments;
              this.isVisableRejectedBy = true;
              this.charCount = this.lstPPEmergency.comments;
              this.rejectedBy = this.lstPPEmergency.rejectedBy + ' ' + this.lstPPEmergency.rejectedOn;
              this.rejectedDate = this.lstPPEmergency.rejectedOn;
              this.isVisableRejectreason = true;
              this.isDisableRejectReason = true;
              this.isDisableDemographicsbutton = true;

            }
          }
          if (this.lstPPEmergency.requestStatus === 'Completed') {
            this.hideRejectbutton = false;
            this.hideRejectReason = false;
            this.isPatientStatus = true;

            this.PatientEmergencyForm.patchValue({
              rejectReason: false
            })
          }
        },
        (err: any) => {
          console.log(err);
        });
  }


  onClick_navigateToUpdateEmergency(insType: string) {
    if (insType === "updateEmergency") {
      sessionStorage.setItem("demoheaderVisibility", "true");
      CommonComponents.demoheaderVisibility = true;
      CommonComponents.patientId = this.lstPPEmergency.patientId;
      sessionStorage.setItem("patientId", this.lstPPEmergency.patientId.toString());
      this.bannerService.toggle(CommonComponents.patientId);
      sessionStorage.setItem("patientId", CommonComponents.patientId.toString());
      sessionStorage.setItem("patientName", CommonComponents.patientName);
      sessionStorage.setItem("displayappDate", null);
      sessionStorage.setItem("displayappDate1", null);
      this.router.navigate(['Demographics/EmergencyEdit', this.emergencyId, this.linkID, this.requestType, 'Portal']); //, insuranceDetails.insuranceId

    } else if (insType === "newEmergency") {
      sessionStorage.setItem("demoheaderVisibility", "true");
      CommonComponents.demoheaderVisibility = true;
      CommonComponents.patientId = this.lstPPEmergency.patientId;
      this.bannerService.toggle(CommonComponents.patientId);
      sessionStorage.setItem("patientId", CommonComponents.patientId.toString());
      sessionStorage.setItem("patientName", CommonComponents.patientName);
      sessionStorage.setItem("displayappDate", null);
      sessionStorage.setItem("displayappDate1", null);
      this.router.navigate(['Demographics/Emergency', this.linkID, this.requestType, 'Portal']);
    }
  }


  onClick_backToMessages() {
    //this.router.navigate(['messageInbox']);
    this.router.navigate(['tasksandmessages/', 'BackToMessages']);
  }
  rejectRequestInfo: MessageInbox;
  onClick_ReasonForReject() {
    this.rejectRequestInfo = this.PatientEmergencyForm.value;
    this.rejectRequestInfo.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.rejectRequestInfo.comments = this.PatientEmergencyForm.value.rejectNotes;
    this.rejectRequestInfo.linkId = this.linkID.toString();
    this.rejectRequestInfo.status = 'Rejected';
    this.rejectRequestInfo.requestType = this.requestType.toString();
    if (this.PatientEmergencyForm.value.rejectNotes != '') {
      this.personalService.updatePatientRequestInformationByLinkId(this.rejectRequestInfo)
        .subscribe(
          (result: any) => {
            this.toastr.success(result)
            this.getPatientRequestDetails(this.linkID);
          },
          (err: any) => {
            console.log(err);
          });
    }


  }

  changeReasonforReject(event: any) {
    if (event.target.checked) {
      this.isVisableRejectreason = true;
      this.isDisableDemographicsbutton = true;

    }
    else {
      this.PatientEmergencyForm.patchValue({
        rejectNotes: ''
      })
      this.isVisableRejectreason = false;
      this.isDisableDemographicsbutton = false;
    }
  }
}
